import { Typography } from "antd";
import PageLayout from "components/molecules/PageLayout";
import MyTasks from "containers/MyTasks";
import { useParams } from "react-router-dom";

const MyTasksPage = (props) => {
    const { tenant } = useParams();
    return (
        <PageLayout
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return <MyTasks setBreadcrumbNavigationItems={setBreadcrumbNavigationItems} tenant={tenant}></MyTasks>;
            }}
            helpContent={
                <Typography>
                    <Typography.Title level={4}>My Assigned Annotations</Typography.Title>
                    <Typography.Paragraph>
                        This page displays all annotations (tasks, issues, and comments) assigned to you across schemas, datasets, and individual records.
                    </Typography.Paragraph>
                    <Typography.Title level={5}>Features:</Typography.Title>
                    <ul>
                        <li>View all annotations where you are the assignee</li>
                        <li>Filter by priority, type, status, and date</li>
                        <li>Sort annotations by creation date</li>
                        <li>Jump to the annotation's context (schema, dataset, or record)</li>
                    </ul>
                </Typography>
            }
        ></PageLayout>
    );
};

export default MyTasksPage;
